import React from 'react';
import { redirectToB2C, redirectToB2B } from '../redirectTool';

import './Selector.scss';
import navigateToB2C from '../../assets/images/navigateTob2c.png';
import navigateToB2B from '../../assets/images/navigateTob2b.png';
import logoSelector from '../../assets/images/logo_selector.svg';

const B2B2CSelector: React.FC = () => {
    React.useEffect(() => {
        document.title = 'SOGYS.APP - Sélection';
    }, []);

    return (
        <div className="selector-container">
            <div className="selector-logo">
                <img src={logoSelector} alt="Logo SOGYS" />
            </div>
            <div className="selector-content">
                <div className="selector-grid">
                    {/* Section Résidentiel (B2C) */}
                    <div className="selector-card">
                        <div className="card-header residential">
                            <h2 className="residential">RÉSIDENTIEL</h2>
                        </div>
                        <div className="card-image">
                            <img src={navigateToB2C} alt="Interface résidentielle sur tablette" onClick={() => redirectToB2C()} />
                        </div>
                        <button type="button" className="card-button residential" onClick={() => redirectToB2C()}>
                            Commencer mon audit
                        </button>
                    </div>

                    {/* Section Professionnel (B2B) */}
                    <div className="selector-card">
                        <div className="card-header professional">
                            <h2 className="professional">PROFESSIONNEL</h2>
                        </div>
                        <div className="card-image">
                            <img src={navigateToB2B} alt="Interface professionnelle sur tablette" onClick={() => redirectToB2B()} />
                        </div>
                        <button type="button" className="card-button professional" onClick={() => redirectToB2B()}>
                            Commencer mon audit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default B2B2CSelector;
